// src/pages/subscription/EntitlementCheckPage.tsx
// Legacy route kept resolvable for old links/bookmarks. Entitlement checks
// now happen through EntitlementCheckDialog (form-kit), opened from
// EntitlementListPage's "Check access" — see docs/ux/14-forms.md. This
// route just sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const EntitlementCheckPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/subscriptions/entitlements', { replace: true });
  }, [navigate]);
  return null;
};

export default EntitlementCheckPage;
